import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-SiteNoteAvailable',
  templateUrl: './SiteNoteAvailable.component.html',
  styleUrls: ['./SiteNoteAvailable.component.css']
})
export class SiteNoteAvailableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
